<div class="number-plate-scan">
  <sc-padding>
    <form class="form" [formGroup]="formGroup">
      <sc-flex vertical stretchContent>
        <mat-form-field appearance="outline" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-simulator.number-plate-scanner"></sc-dictionary-label>
          </mat-label>
          <mat-select (valueChange)="onCameraSelection($event)">
            @for (camera of cameras; track camera) {
              <mat-option [value]="camera">
                {{ camera.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <sc-string-field formControlName="numberPlateNumber" labelDictionaryKey="tmc-yard.entity.transport.numberplate"/>
        <sc-content-spacer vertical/>
        <!-- <mat-form-field> -->
          <input #fileChooser type="file" class="fileupload-field" (change)="onFileSelected($event)" #fileUpload accept="image/*">
        <!-- </mat-form-field> -->
        <sc-content-spacer vertical/>
        <sc-string-field formControlName="weighingSource" label="Quelle Wiegung"/>
        <sc-content-spacer vertical/>
        <sc-decimal-field formControlName="weight" label="Wiegeergebnis"/>
        <sc-content-spacer/>

      </sc-flex>
    </form>

    <sc-button dictionaryKey="tmc-yard.ui.admin.yard-simulator.send" primary class="config-changed-button" (click)="onButtonTrigger()"
    [disabled]="!numberPlateNumber || !cameraSelected"></sc-button>
  </sc-padding>
</div>
